export default "<div class=\"password-toggle__btn\">\n    {% include 'icon', size: 'm', type: 'eye-open' %}\n</div>\n";